module.exports = __webpack_public_path__ + "assets/media/swallow_split_mix.0202e7fe.mp4";